import React, {
    ReactElement, useState,
    useEffect,
} from "react";
import useRouting, { useParams } from "../../../contexts/Routing";
import useCurrentSession from "../../../contexts/UserContext";
import { Permission, useLoginWithTokenMutation } from "../../../__generated__/api";
import isAllowedRedirect from "../../../redirect";
import Styles from "./LoginWithToken.module.scss";

const SIDE_IMAGE = "https://static.foqal.io/agent/welcome-bot-md.png";
const ERROR_IMAGE = "https://static.foqal.io/agent/failbot.png";

export default function LoginWithToken(): ReactElement {
    const { invalidate } = useCurrentSession();
    const { Paths, historyPushWithSearch, getSearchParams } = useRouting();
    const { token } = useParams(Paths.LOGIN_WITH_TOKEN);
    const { redirect } = getSearchParams(Paths.LOGIN_WITH_TOKEN);

    const [loginError, setLoginError] = useState<string | null>();
    const [loginHandler] = useLoginWithTokenMutation();

    useEffect(() => {
        const handle = async () => {
            try {
                const response = await loginHandler({ variables: { token } });
                if (response.data?.loginWithToken.__typename === "LoginError") {
                    setLoginError("Invalid or expired token");
                } else {
                    invalidate();

                    let redirectPath: string;
                    const permissions = new Set(response.data?.loginWithToken.permissions);
                    if (redirect) {
                        redirectPath = redirect;
                    } else if (permissions.has(Permission.ChatsModify)) {
                        redirectPath = Paths.AGENT;
                    } else if (permissions.has(Permission.TicketsReadSelf)) {
                        redirectPath = Paths.TICKETS;
                    } else {
                        redirectPath = Paths.ANSWERS_LIST;
                    }

                    if (!isAllowedRedirect(redirectPath)) {
                        redirectPath = "/";
                    }
                    historyPushWithSearch(Paths.DEFAULT, {
                        isWaitLogin: "true",
                        redirect: redirectPath,
                    });
                }
            } catch (err) {
                setLoginError((err as {message: string}).message);
            }
        };
        handle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <div className="full-page">
            <div className="centered-container centered-container-md pt-5">
                <div className="d-flex w-100 align-items-center">
                    <img
                        src={loginError ? ERROR_IMAGE : SIDE_IMAGE}
                        alt="Side icon"
                        className={` ${Styles["side-image"]}`}
                    />

                    <div className="flex-grow-1 text-center">
                        {loginError ? (
                            <h4>{loginError}</h4>
                        ) : (
                            <h3>Logging in...</h3>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}
